import { VenuePage } from "../../types/venues";
import { VenueUserConfig } from "../../types/VenueUser";

/**
 * Returns only the venues the user has explicit permission to access.
 *
 * Mirrors the Collins UI `getVenuesForUser` behaviour:
 * - `venues === true` grants access to every venue in the group.
 * - `venues` as an array of ids restricts access to those venues.
 * - Anything else (e.g. config not yet loaded) grants access to none.
 */
export const getPermittedVenues = (
  venues: VenuePage[] | undefined,
  venueUserConfig: VenueUserConfig | null
): VenuePage[] => {
  if (!venues) {
    return [];
  }

  const permittedVenueIds = venueUserConfig?.venues;

  if (permittedVenueIds === true) {
    return venues.filter((venue) => !!venue.title);
  }

  if (Array.isArray(permittedVenueIds)) {
    return venues.filter(
      (venue) => !!venue.title && permittedVenueIds.includes(venue._id)
    );
  }

  return [];
};
